// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
  font-family: "WMFD-Bold";
  color: white;
  background-color: var(--primary-color);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1rem;
  transition: 0.5s ease-in-out;
  transition-property: transform;
}

footer #logo {
  max-width: 35vw;
}

#back-to-top {
  border-bottom: 1px solid;
}

#footer-container {
  display: flex;
  justify-content: space-between;
  padding: 0rem 2rem;
  margin-top: 2rem;
  width: 90%;
}

#footer-left {
  margin: 1rem 0rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  max-width: 40vw;
  overflow: hidden;
  gap: 2rem;
}

#footer-right {
  margin: 1rem 0rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  max-width: 40vw;
}

#footer-social-media {
  display: flex;
  flex-direction: row;
}

#footer-address {
  font-family: "WMFD-Bold";
}

#footer-contact {
  font-family: "WMFD-Bold";
}

@media (max-width: 600px) {
  #footer-left {
    max-width: 80vw;
    align-items: center;
    gap: 0;
  }

  #footer-right {
    max-width: 80vw;
  }
  #footer-container {
    flex-direction: column;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,YAAY;EACZ,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,MAAM;EACR;;EAEA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF","sourcesContent":["footer {\r\n  font-family: \"WMFD-Bold\";\r\n  color: white;\r\n  background-color: var(--primary-color);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding-bottom: 1rem;\r\n  transition: 0.5s ease-in-out;\r\n  transition-property: transform;\r\n}\r\n\r\nfooter #logo {\r\n  max-width: 35vw;\r\n}\r\n\r\n#back-to-top {\r\n  border-bottom: 1px solid;\r\n}\r\n\r\n#footer-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  padding: 0rem 2rem;\r\n  margin-top: 2rem;\r\n  width: 90%;\r\n}\r\n\r\n#footer-left {\r\n  margin: 1rem 0rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  min-height: 100%;\r\n  max-width: 40vw;\r\n  overflow: hidden;\r\n  gap: 2rem;\r\n}\r\n\r\n#footer-right {\r\n  margin: 1rem 0rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  min-height: 100%;\r\n  max-width: 40vw;\r\n}\r\n\r\n#footer-social-media {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n\r\n#footer-address {\r\n  font-family: \"WMFD-Bold\";\r\n}\r\n\r\n#footer-contact {\r\n  font-family: \"WMFD-Bold\";\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  #footer-left {\r\n    max-width: 80vw;\r\n    align-items: center;\r\n    gap: 0;\r\n  }\r\n\r\n  #footer-right {\r\n    max-width: 80vw;\r\n  }\r\n  #footer-container {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
